module.exports = __webpack_public_path__ + "static/media/nyc.d4ebbfe1.jpg";